import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin } from "antd";
import { SearchOutlined, BarsOutlined, LoadingOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import http from "../../../services/http";
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const EleicoesCipaLocalidadesFiliais = ({ to }) => {
  const { id_localidade } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS
  const [localidade, setLocalidade] = useState({});

  useEffect(() => {
    if (id_localidade) {
      carrgearLocalidade(id_localidade);
      listarFiliais(id_localidade);
    }
  }, [id_localidade]);

  // CARREGAR LOCALIDADE
  const carrgearLocalidade = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_localidades/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate(to);
      }
      setLocalidade(api?.response?.data ?? []);
    } else {
      navigate(to);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarFiliais = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/eleicoes_cipa_localidades_filiais/listar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      setDados(response?.data ?? []);
      setSelected(response?.checked ?? []);
    } else {
      navigate(to);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SALVAR
  const salvarLocalidadesFiliais = async (filiais_selected, filiais, id) => {
    setLoading(true);

    let array_filiais = [];
    filiais?.map((e) => array_filiais.push(e.key));

    const dados_envio = {
      id_cad_localidades: id,
      id_cad_filiais: array_filiais,
      id_cad_filiais_checked: filiais_selected,
    };

    const api = await http("post", `v1/eleicoes_cipa_localidades_filiais/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_filiais.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...filiais_selected]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Filial <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "filial",
      sorter: (a, b) => a.filial?.localeCompare(b.filial),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.filial?.toLowerCase().includes(pesquisar.toLowerCase()));

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? false : true;
        });
        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? true : false;
        });
        break;
      default:
        break;
    }

    return filteredData;
  };

  // DADOS FILTRADOS
  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarLocalidadesFiliais(array, dadosFilter, id_localidade);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarLocalidadesFiliais(status ? [data.key] : [], [{ key: data.key }], id_localidade);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Cadastro de Localidades" onClickBack={() => navigate(to)} />
            <HeaderTitle
              title={["Localidades", "Filiais"]}
              subtitle={
                <Text italic>
                  <EnvironmentOutlined /> {localidade?.descricao ?? ""}
                </Text>
              }
              icon={<BarsOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    defaultValue={0}
                    value={marcado}
                    style={{ width: 180, maxWidth: "100%" }}
                    onChange={(e) => setMarcado(e)}
                    options={optionsFiltro}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
